export default "__VITE_ASSET__boHlnRrr__"